import { Pipe, PipeTransform } from "@angular/core";
import { LgTranslateService } from "@logex/framework/lg-localization";
import { AppDefinitions } from "../services";
import { Address } from "../types";

@Pipe({
    name: "asAddress",
    pure: true
})
export class AddressPipe implements PipeTransform {
    constructor(private _definitions: AppDefinitions, private _translate: LgTranslateService) {}

    transform(address: Address): any {
        if (address == null) return "";

        const addressOrPostBox = address.postBox
            ? `${this._translate.translate("APP._OrganizationDetail.Labels.PostBox")} ${
                  address.postBox
              }`
            : `${address.street} ${address.houseNumber} ` +
              `${address.houseNumberSuffix || ""} ${address.buildingExtension || ""}`;

        return (
            addressOrPostBox.trim() +
            `, ` +
            `${address.postalCode} ${address.city}, ` +
            this._definitions.getDisplayName("country", address.countryCode)
        );
    }
}
